import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, Star } from 'lucide-react';
import StarRating from './StarRating';

const ProductCard = ({ product, onAddToCart }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.4 }}
      whileHover={{ y: -6 }}
      className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100 dark:border-gray-700 overflow-hidden group relative"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-orange-500/0 via-orange-500/0 to-orange-500/0 group-hover:via-orange-500/5 group-hover:to-orange-500/10 transition-all duration-500 pointer-events-none" />
      <div
        className="relative h-48 bg-gray-50 dark:bg-gray-700 overflow-hidden cursor-pointer"
        onClick={() => navigate(`/store/products/${product.id}`)}
      >
        {product.image_url ? (
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
        ) : (
          <div className="flex items-center justify-center h-full text-gray-400">
            <ShoppingCart className="w-12 h-12" />
          </div>
        )}
        {product.star_rating === 'top' && (
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="absolute top-2 right-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-lg"
          >
            TOP
          </motion.span>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      <div className="p-4 relative">
        <div className="mb-1">
          <StarRating rating={product.star_rating} size="sm" />
        </div>
        <h3
          className="font-semibold text-gray-900 dark:text-white mb-1 truncate cursor-pointer hover:text-orange-500 transition-colors"
          onClick={() => navigate(`/store/products/${product.id}`)}
        >
          {product.name}
        </h3>
        {product.category_name && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">{product.category_name}</p>
        )}
        <div className="flex items-center justify-between mt-3">
          <div>
            <span className="text-lg font-bold bg-gradient-to-r from-orange-500 to-orange-600 bg-clip-text text-transparent">
              ${product.price.toFixed(2)}
            </span>
            {product.vu > 0 && (
              <span className="text-xs text-gray-500 dark:text-gray-400 ml-2">
                VU: ${product.vu.toFixed(2)}
              </span>
            )}
          </div>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => onAddToCart?.(product)}
            className="p-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl hover:shadow-lg hover:shadow-orange-500/30 transition-all"
          >
            <ShoppingCart className="w-4 h-4" />
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;
